import { api } from './api'

export const loginWithCode = async (
  email: string,
  tableId?: string | null
): Promise<{ success: boolean }> => {
  const searchParams = new URLSearchParams()
  searchParams.append('email', email)
  if (tableId) searchParams.append('tableId', tableId)

  const searchString = searchParams.size !== 0 ? `?${searchParams.toString()}` : ''
  const endpoint = `/api/auth/login-with-code${searchString}`
  return await api().url(endpoint).post({}).json()
}
